"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var useEditableField_1 = require("@features/ItemCommon/hooks/useEditableField");
var ConfirmRevertButtons_1 = __importDefault(require("@components/ConfirmRevertButtons"));
var react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
var Htmlizer_1 = __importDefault(require("@components/Htmlizer"));
var useHtmlizer_1 = require("@features/ItemCommon/hooks/useHtmlizer");
function JobTitle(_a) {
    var _b, _c;
    var isNotEditable = _a.isNotEditable, setValue = _a.setValue, job = _a.job, angularJsDependencies = _a.angularJsDependencies, domain = _a.domain;
    var textAreaRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    var value = (_c = (_b = job.ad) === null || _b === void 0 ? void 0 : _b.current.content) === null || _c === void 0 ? void 0 : _c.title;
    var _d = (0, useEditableField_1.useEditableField)(value, isNotEditable, setValue, textAreaRef), mode = _d.mode, handleClick = _d.handleClick, onClickOutside = _d.onClickOutside, resetToOriginalValue = _d.resetToOriginalValue, confirmChanges = _d.confirmChanges, tempValue = _d.tempValue, setTempValue = _d.setTempValue;
    var _e = (0, useHtmlizer_1.useHtmlizer)(containerRef, onClickOutside, mode, tempValue, value, '$title,$text', 'title', job, domain, angularJsDependencies), htmlParts = _e.htmlParts, updateHtmlParts = _e.updateHtmlParts, handleKeyDown = _e.handleKeyDown;
    var classes = (0, clsx_1.default)({
        'eva-job-title': true,
        'eva-job-title-edit': mode === 'EDIT',
        'flex-container': true,
        'flex-align-item-middle': true,
    });
    return (react_1.default.createElement("div", { className: classes, "data-cy": "job-title", ref: containerRef },
        mode === 'VIEW' && (react_1.default.createElement("div", { onClick: handleClick, className: (0, clsx_1.default)('flex-item', 'flex-container', 'eva-text-view', { 'eva-text-view--disabled': isNotEditable }) }, value ? (react_1.default.createElement("span", { "data-cy": "job-title-value" }, htmlParts && Array.isArray(htmlParts) && htmlParts.length > 0 ? (react_1.default.createElement(Htmlizer_1.default, { domain: domain, htmlParts: htmlParts, value: value })) : (value))) : (react_1.default.createElement("span", null, (job === null || job === void 0 ? void 0 : job.titleWithPlaceholder) || '')))),
        mode === 'EDIT' && (react_1.default.createElement("div", { className: "eva-job-text-area eva-job-text-area-edit eva-job-text-area-title flex-container" },
            react_1.default.createElement(react_textarea_autosize_1.default, { "data-cy": "job-title-input", className: "form-control inputs-should-respond-to-keyboard-arrows", placeholder: (job === null || job === void 0 ? void 0 : job.titleWithPlaceholder) || '', onChange: function (e) { return setTempValue(e.currentTarget.value); }, value: tempValue || '', onKeyDown: handleKeyDown, rows: 1, ref: textAreaRef }),
            react_1.default.createElement(ConfirmRevertButtons_1.default, { name: "job-title-button", onConfirmClicked: function () {
                    confirmChanges(tempValue || '');
                    updateHtmlParts(tempValue || '');
                }, onRevertClicked: function () {
                    resetToOriginalValue();
                } })))));
}
exports.default = JobTitle;
